<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal event-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Meeting</h3>

        <b-form role="form" @submit.prevent="submit()">
            <b-row>

                <input type="text" v-model="model.meeting_id" hidden>
                <input type="text" v-model="model.lead_id" hidden>
                <input type="text" v-model="model.meeting_status" hidden>

                <!-- FIELD LEADS -->
                <b-col cols="12">
                    <b-form-group label="Lead">
                        <el-select v-model="model.lead_id" filterable placeholder="Select" disabled>
                            <el-option
                            v-for="lead in leadName"
                            :key="lead.lead_id"
                            :label="lead.name"
                            :value="lead.lead_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <!-- FIELD ASSIGN TO -->
                <!-- <b-col cols="12">
                    <b-form-group label="Assign To Hub">
                        <el-select v-model="new_meeting.assigned_to" filterable placeholder="Select">
                            <el-option
                            v-for="hub in hubName"
                            :key="hub.hub_id"
                            :label="hub.hub_name"
                            :value="hub.hub_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col> -->

                <!-- FIELD STATUS COLOR -->
                <!-- <b-col cols="12">
                    {{ new_meeting.status }}
                    <b-form-group label="Status Color: ">
                        <div class="btn-group btn-group-toggle btn-group-colors event-tag">
                            <label
                            v-for="(color, index) in eventColors"
                            :key="index"
                            class="btn"
                            :class="[color.label, { 'active focused': new_meeting.className === color.label }]"
                            >
                            <input
                                v-model="new_meeting.className"
                                type="radio"
                                name="event-tag"
                                :value="color.label"
                                autocomplete="off"
                            />
                            </label>
                        </div>
                    </b-form-group>
                </b-col> -->

                <!-- FIELD TITLE -->
                <b-col cols="12">
                    <b-form-group label="Title">
                        <b-form-input
                            v-model="model.title"
                            type="text"
                            required
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <!-- FIELD DATE START -->
                <b-col cols="12" md="6">
                    <b-form-group label="Date Start">
                        <!-- <b-form-input
                        :value="startValue"
                        @input="updateStartValue"
                        type="datetime"
                        required
                        readonly
                        ></b-form-input> -->
                        <b-form-datepicker :value="model.start" id="dateInput" readonly></b-form-datepicker>
                    </b-form-group>
                </b-col>

                <!-- FIELD DATE END -->
                <b-col cols="12" md="6">
                    <b-form-group label="Date End">
                        <!-- <b-form-input
                        :value="endValue"
                        @input="updateEndValue"
                        type="datetime-local"
                        required
                        ></b-form-input> -->
                        <b-form-datepicker v-model="model.end"></b-form-datepicker>
                    </b-form-group>
                </b-col>

                <!-- FIELD TIME START -->
                <b-col cols="12" md="6">
                    <b-form-group label="Time Start">
                        <el-time-picker
                            v-model="model.start_time"
                            placeholder="Time Start"
                            format="HH:mm A"
                            value-format="HH:mm:ss"
                            >
                        </el-time-picker>
                    </b-form-group>
                </b-col>
            
                <!-- FIELD TIME END -->
                <b-col cols="12" md="6">
                    <b-form-group label="Time End">
                        <el-time-picker
                                v-model="model.end_time"
                                placeholder="Time End"
                                format="HH:mm A"
                                value-format="HH:mm:ss"
                                >
                        </el-time-picker>
                    </b-form-group>
                </b-col>

                <!-- FIELD DESCRIPTION -->
                <b-col cols="12">
                    <b-form-group label="Description">
                        <b-form-textarea
                            id="textarea"
                            v-model="model.description"
                            placeholder="Description"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>

                <!-- SUBMIT BUTTON -->
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button type="submit" class="w-100" variant="primary">Update</b-button>
                </b-col>
            </b-row>
        </b-form>

        <!-- <b-form ref="AddMeetingForm" role="form" @submit.prevent="submit()">
            <b-row>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button type="submit" class="w-100" variant="primary">Schedule</b-button>
                </b-col>
            </b-row>
        </b-form> -->

        <!-- <template v-slot:footer>
            <base-button type="link" class="mr-auto" @click="show = false">Close</base-button>
            <base-button
                native-type="submit"
                type="primary"
                class="new-event--add"
                @click="submit"
                >Update</base-button
            >
        </template> -->

    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, TimePicker } from 'element-ui'
import {

    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { useLeadStore } from '@/stores/leadStore'
import { mapActions } from 'pinia'

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default {
    props: {
        edit_meeting: Boolean,
        meetingList: Array,
        start: Date,
        end: Date,
        dateInfo: Object,
        timelineEdited: Object,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
        [TimePicker.name]: TimePicker,
    },
    created(){
        this.fetchLead()
        if(this.checkAppCode('sas')){
            // this.fetchHub()
        }
    },
    computed: {
        show: {
            get() {
                return this.edit_meeting;
            },
            set(newVal) {
                this.$emit('update:edit_meeting', newVal);
            },
        },
    },
    watch: {
        start: {
            immediate: true,
            handler(newValue) {
                this.new_meeting.start = newValue;
                this.new_meeting.status = "Scheduled"
            }
        },
        end: {
            immediate: true,
            handler(newValue) {
                this.new_meeting.end = newValue;
            }
        },
        // 'new_meeting.isComplete'(value) {
        //     // Toggle the value of 'otherData' based on the checkbox state
        //     this.new_meeting.status = value ? 'Completed' : 'Scheduled';
        // },
        // 'dateInfo.startStr'(newVal){
        //     var timeString = newVal.split("T")[1];
        //     this.new_meeting.time_start = timeString
        // },
        // 'dateInfo.endStr'(newVal){
        //     var timeString = newVal.split("T")[1];
        //     this.new_meeting.time_end = timeString
        // },
        'timelineEdited'(newVal){
            this.model.meeting_id = newVal.meeting_id
            this.model.lead_id = Number(newVal.lead_id)
            this.model.title = newVal.subject
            this.model.description = newVal.description
            this.model.start = this.getDataDate(newVal.start_at)
            this.model.end = this.getDataDate(newVal.end_at)
            this.model.start_time = this.getDataTime(newVal.start_at)
            this.model.end_time = this.getDataTime(newVal.end_at)
            this.model.meeting_status = newVal.meeting_status
            this.model.remark_meeting = newVal.remark_meeting
            this.model.className = newVal.meeting_status
        }

    },
    data() {
        return {
            new_meeting: {
                lead_id: '',
                assigned_to: '',
                className: 'event-default',
                title: '',
                duration: '',
                description: '',
                type: '',
                location: '',
                start: '',
                end: '',
                time_start:'',
                time_end:'',
                date_end:'',
                isComplete:false,
                remark_meeting:'',
                status:'Scheduled'
            },
            profileName: [{
                value: 'Mena',
                label: 'Mena'
                }, {
                value: 'Raziq',
                label: 'Raziq'
                }, {
                value: 'Anthony',
                label: 'Anthony'
                }, {
                value: 'Ben Parker',
                label: 'Ben Parker'
                }, {
                value: 'Masdo',
                label: 'Masdo'
            }],
            durationOptions: [{
                value: '30 mins',
                label: '30 mins'
                }, {
                value: '40 mins',
                label: '40 mins'
                }, {
                value: '60 mins',
                label: '60 mins'
                }, {
                value: '90 mins',
                label: '90 mins'
                }, {
                value: '120 mins',
                label: '120 mins'
            }],
            typeOptions: [
                { text: 'Offline', value: 'offline' },
                { text: 'Online', value: 'online' },
            ],
            // eventColors: [
			// 	"event-default",
			// 	"event-green",
			// 	"event-orange",
			// 	"event-red",
            // ],
            eventColors: [
          {
          value:"1",
          label:"event-default",
          status:"Scheduled"
          },
          {
          value:"2",
            label:"event-green",
            status:"Completed"
          },
          {
          value:"3",
            label:"event-orange",
            status:"Postponed"
          },
          {
          value:"4",
            label:"event-red",
            status:"Canceled"
          },
        ],
            leadName:[],
            hubName:[],
            minimumTime: "00:00",
            testtry: "",
            model: {
                meeting_id: "1",
                title: "New event",
                className: "bg-default",
                description:
                "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
                start: "",
                end: "",
                start_time: "",
                end_time: "",
                lead_id:"",
                meeting_status:"",
                remark_meeting:""
            },
        }
    },
    methods: {
        ...mapActions(useLeadStore,['getLeadActivityLog']),
        checkii(event){
            if(this.new_meeting.isComplete  == false){
                this.new_meeting.status = "Completed"
                this.new_meeting.isComplete = true
            }else{
                this.new_meeting.status = "Scheduled"
                this.new_meeting.isComplete = false
            }
        },
        updateStartValue(event) {
            this.startValue = event
        },
        updateEndValue(event) {
            this.endValue = event
        },
        submit(){
            const form = {
                'lead_id': this.model.lead_id,
                'subject': this.model.title,
                'description': this.model.description,
                'meeting_status': this.model.className,
                'start_at': this.model.start,
                'end_at': this.model.end,
                'time_start': this.model.start_time,
                'time_end': this.model.end_time,
                'remark_meeting': this.model.remark_meeting,
            }

            axios.put(services.lead + 'meeting/' + this.model.meeting_id , form, { headers: getHeader() })
                .then(res => {
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                    this.show = false
                    this.$emit('getTimeline')
                    this.getLeadActivityLog(this.$route.params.lead_id)
                    // this.getAllMeeting()
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        fetchLead(){
            axios.get(services.lead + 'leads', {headers: getHeader()})
                .then(res => {
                    this.leadName = res.data.data.data
                    this.$emit('listLead',res.data.data.data)
                })
                .catch(e => {
                    this.isTableLoading = false
                    this.errorFunction(e)
                })
            },
        fetchHub(){
            axios.get(services.hub + 'hubs', {headers: getHeader()})
                .then(res => {
                    this.hubName = res.data.data
                })
                .catch(e => {
                    this.isTableLoading = false
                    // this.errorFunction(e)
                })
        },
        getDataTime(data){
            const newdata = new Date(data)
            const data_hours = newdata.getHours().toString().padStart(2,'0')
            const data_minutes = newdata.getMinutes().toString().padStart(2,'0')
            const data_seconds = newdata.getSeconds().toString().padStart(2, '0');

            return `${data_hours}:${data_minutes}:${data_seconds}`
        },
        getDataDate(data){
            const newDate = new Date(data);

            const year = newDate.getFullYear();
            const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
            const day = newDate.getDate().toString().padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
    }
}
</script>